/* eslint-disable no-empty-pattern */
import { IconButton, Tooltip } from '@material-ui/core';
import React from 'react';
import { Wrapper } from './ActionsGenerator.Styles';
export var ActionsGenerator = function (_a) {
    var rowData = _a.rowData, actions = _a.actions;
    return (React.createElement(Wrapper, null, actions.map(function (actions) {
        var Icon = actions.icon, tooltip = actions.tooltip, disabled = actions.disabled, onClick = actions.onClick;
        return (React.createElement(Tooltip, { title: tooltip },
            React.createElement(IconButton, { "aria-label": 'upload picture', disabled: disabled, onClick: function () { return onClick(rowData, rowData.data); }, size: 'small' },
                React.createElement(Icon, null))));
    })));
};
ActionsGenerator.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=ActionsGenerator.js.map